export enum ActionType {
  CREATE = 'CREATE',
  LINK = 'LINK',
}

export type InviteLinkInfoType = {
  invitee: string;
  inviter: string;
  linkAccountActionType: ActionType;
};

export enum BadgeType {
  SUCCESS = 'success',
  PENDING = 'pending',
  ERROR = 'error',
  CUSTOM = 'custom',
}
